import { B2B_CERT_UPLOAD_URL, TSDIGITAL_PORTALE_URL } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization, createHttpHeaderForB2bCert } from "../../services/http-header";

export function generateValidationDocument(body, id) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantUuidSelected = getState().main.accountantUuidSelected;
  
    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };
  
    return new Promise(function(resolve, reject) {
      dispatch({
        type: "GENERATE_VALIDATION_DOCUMENT_START"
      });
  
      let request = {
        method: "POST",
        url: `${TSDIGITAL_PORTALE_URL}/api/items/${id}/contract/generate`,
        data: body,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };
  
      callWithRetry(
        auth, request, dispatch
      )
        .then(response => {
          dispatch({
            type: "GENERATE_VALIDATION_DOCUMENT_SUCCESS",
            payload: response.data
          });
          resolve(response.data);
        })
        .catch(err => {
          dispatch({
            type: "GENERATE_VALIDATION_DOCUMENT_ERROR",
            error: err.toString()
          });
          reject(err);
        });
    });
  };
}

export function uploadValidationDocument(body, data) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const user = getState().user;
    // const accountantUuidSelected = getState().main.accountantUuidSelected;

    const bodyToSend = {
      auth: {
        id: auth?.loginAuth?.id,
        securityToken: auth?.loginAuth?.securityToken,
        appName: "DIGITALBOX",
        requestId: auth?.loginAuth?.requestId,
        correlationId: auth?.loginAuth?.correlationId,
        accessToken: auth?.accessToken,
        idToken: auth?.loginAuth?.idToken,
        locale: user?.profile?.language
      },
      id: data?.id,
      description: data?.ragioneSociale,
      content: body?.base64
    };
  
    return new Promise(function(resolve, reject) {
      dispatch({
        type: "UPLOAD_VALIDATION_DOCUMENT_START"
      });
  
      let request = {
        method: "POST",
        url: `${B2B_CERT_UPLOAD_URL}/upload`,
        data: bodyToSend,
        headers: {
          ...createHttpHeaderForB2bCert(user?.profile?.language || "it-IT")
        }
      };
  
      callWithRetry(
        auth, request, dispatch
      )
        .then(response => {
          dispatch({
            type: "UPLOAD_VALIDATION_DOCUMENT_SUCCESS",
            payload: response.data
          });
          resolve(response.data);
        })
        .catch(err => {
          dispatch({
            type: "UPLOAD_VALIDATION_DOCUMENT_ERROR",
            error: err.toString()
          });
          reject(err);
        });
    });
  };
}